import React from 'react';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  href?: string;
  className?: string;
  size?: 'sm' | 'md';
}
export function CTAButton({
  text,
  subtext,
  href,
  className = '',
  size = 'md'
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (!href) {
      e.preventDefault();
      document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const isSmall = size === 'sm';
  const ButtonContent = <div className={`relative w-full group cta-pulse ${className}`} data-id="element-43">
      <div className={`absolute -inset-1 bg-gradient-to-r from-green-500 to-lime-500 rounded-xl ${isSmall ? 'opacity-50' : 'opacity-70'} md:group-hover:opacity-100 transition duration-200`} data-id="element-44"></div>
      <button onClick={handleClick} className={`relative w-full flex flex-col items-center justify-center bg-gradient-to-b from-green-500 to-green-700 border-b-4 border-green-900 rounded-xl shadow-2xl text-white font-black uppercase tracking-wide md:hover:from-green-400 md:hover:to-green-600 transition-all ${isSmall ? 'px-4 py-3 text-base md:text-lg' : 'px-6 py-4 text-xl md:text-2xl'}`} data-id="element-45">
        <div className="flex items-center gap-2 text-center" data-id="element-46">{text}</div>
        {subtext && <span className={`font-medium text-green-100 mt-1 normal-case tracking-normal ${isSmall ? 'text-xs md:text-sm' : 'text-sm md:text-base'}`} data-id="element-47">
            {subtext}
          </span>}
      </button>
    </div>;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-48">
        {ButtonContent}
      </a>;
  }
  return ButtonContent;
}